module.exports = __webpack_public_path__ + "img/MRM.9f5ae403.svg";